import React from 'react';
import HyvidLogo from 'assets/img/logo/Hyvid_Logo.png';
import { ReactComponent as IntsamisLogo } from 'assets/svg/intsamis_logo.svg';

const AccountLogo = ({accountId, extra, logoClass, companyNameClass,  ...props}) => {

  	return (    
	    <div className={`${extra}`}>
			{ accountId == 2 ? 
				<div className="flex items-center gap-2">
					<IntsamisLogo className="w-[80px] h-auto"/>
					<h2 className="font-bold text-[28px]">INTSAMIS</h2>
				</div>
			:
				<div className={`${logoClass}`}>
					<img src={HyvidLogo} alt="Hyvid" style={{'maxWidth':'200px'}}/>
				</div>
			}
	  	</div>
  	);
};

export default AccountLogo;